import React from 'react';
import { motion } from 'framer-motion';
import { BulkrrLogo } from './BulkrrLogo';
export function SplashScreen() {
  return <motion.div className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center" initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.4,
    ease: 'easeInOut'
  }} data-id="element-3232" data-mp="3jqseuu7hqh9j">
      <div className="flex flex-col items-center" data-id="element-3233" data-mp="2w1g61vg2sb7r">
        <motion.div initial={{
        scale: 0.5,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 20,
        duration: 0.6
      }} data-id="element-3234" data-mp="2w0o8wg6ty5fd">
          <BulkrrLogo variant="full" size="xl" data-id="element-3235" data-mp="2d4eyq3z1tz0n" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.5
      }} className="mt-4 text-muted-foreground font-medium text-lg" data-id="element-3236" data-mp="2i1ojv7fenoio">
          Slim boodschappen doen
        </motion.p>
      </div>
    </motion.div>;
}